module.exports = __webpack_public_path__ + "img/bandeau-JPO-1.c802b37.png";